import Box, { type BoxProps } from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { SortOrder } from "consts/request-query";
import type { IncrementTaxes as MerchantPayoutIncrementTaxes } from "features/merchantPayouts/types";
import { PaymentMethod } from "ui/molecules/PaymentMethod";
import { Collection, Resource } from "ui/support/Resource";
import GroupedFees from "./GroupedFees";
import useFeesAndCommisions from "./useFeesAndCommisions";
import withPaymentMethod from "./withPaymentMethod";

const FeesAndCommisions = ({ sx }: BoxProps) => {
    const { getMethodFees, groupIncrementTaxesBy } = useFeesAndCommisions();

    const fees = Object.entries<Array<MerchantPayoutIncrementTaxes>>(groupIncrementTaxesBy({
        groupByKey: 'tag',
        incrementTaxes: getMethodFees()
    }));

    return (
        <Resource
            isEmpty={!fees.length}
            emptySlot={<></>}
        >
            <Typography
                variant='h5'
            >
                Method Fees
            </Typography>
            <Collection
                sx={{
                    display: 'grid',
                    gap: 2
                }}
                collection={fees}
                renderResource={([tag, methodFees]) => (
                    <Resource
                        key={tag}
                        isEmpty={!methodFees.length}
                        emptySlot={<></>}
                    >
                        <Box
                            sx={{
                                display: 'grid',
                                gap: 2
                            }}
                        >
                            <PaymentMethod
                                tag={tag}
                            >

                            </PaymentMethod>
                            <GroupedFees
                                sx={sx}
                                tag={tag}
                                incrementTaxes={methodFees}
                                sortOrder={SortOrder.Asc}
                            />
                        </Box>
                    </Resource>
                )}
            />
        </Resource>
    );
};

export default withPaymentMethod(FeesAndCommisions);
